import { gql, TypedDocumentNode } from "@apollo/client";

import { ApiKeyView } from "./types";

export type GetApiKeyData = {
  apiKey: ApiKeyView;
};

export const GET_API_KEY: TypedDocumentNode<GetApiKeyData> = gql`
  query GetApiKey($id: ID!) {
    apiKey(id: $id) {
      id
      creator
      description
      lastUsedAt
      teams
      name
      type
      oidcSettings {
        clientId
        issuer
        subjectExpression
      }
      apiKeyRoleBindings {
        id
        apiKeyID
        spaceID
        role {
          id
          name
          description
          isSystem
        }
      }
    }
  }
`;
